import { render } from "./LazyYoutube.vue?vue&type=template&id=1f5eb252"
import script from "./LazyYoutube.vue?vue&type=script&lang=js"
export * from "./LazyYoutube.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__